/*@ngInject*/
const UIScrollToBottomDirective = function ($timeout, coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {
        let element = $($elm);

        function scrollToBottom() {
            $timeout(function () {
                element.animate({
                    scrollTop: element[0].scrollHeight
                }, 300);
            }, 100);
        }

        $scope.$on(coreConstant.event.SCROLL_TO_BOTTOM, function (event) {
            scrollToBottom();
        });
    };

    return {
        restrict: 'A',
        link: linkFunction,
        scope: {
            scrollableListLength: '<'
        }
    };
};

angular.module('umCore')
    .directive('uiScrollToBottom', UIScrollToBottomDirective);
